"use strict";
/**
 * @module
 *
 * Atomic values that can be set and overwritten which trace through the render
 * tree. Can be used with common props, such as:
 *
 * - Accent color
 * - Background color
 * - Border roundness
 * - Disabled/read-only state
 * - etc.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSubtleTrace = exports.useHiddenTrace = exports.SetTraces = exports.SetNamedTrace = exports.SetTrace = exports.useTrace = exports.ctx = void 0;
const react_1 = require("react");
exports.ctx = (0, react_1.createContext)({});
const useTrace = (key) => (0, react_1.useContext)(exports.ctx)[key];
exports.useTrace = useTrace;
const SetTrace = ({ children, name, value: _value }) => {
    const parentValue = (0, react_1.useContext)(exports.ctx);
    const value = (0, react_1.useMemo)(() => ({ ...parentValue, [name]: _value }), [name, _value, parentValue]);
    return (0, react_1.createElement)(exports.ctx.Provider, { value, children });
};
exports.SetTrace = SetTrace;
exports.SetNamedTrace = exports.SetTrace;
const SetTraces = ({ children, value: _value }) => {
    const parentValue = (0, react_1.useContext)(exports.ctx);
    // biome-ignore lint/correctness/useExhaustiveDependencies: _value entries are spread into deps to track its keys/values individually
    const value = (0, react_1.useMemo)(() => ({ ...parentValue, ..._value }), [...Object.entries(_value).flat(), parentValue]);
    return (0, react_1.createElement)(exports.ctx.Provider, { value, children });
};
exports.SetTraces = SetTraces;
// ------------------------------------------------------------ Specific traces
const useHiddenTrace = () => !!(0, exports.useTrace)('hidden');
exports.useHiddenTrace = useHiddenTrace;
const useSubtleTrace = () => !!(0, exports.useTrace)('subtle');
exports.useSubtleTrace = useSubtleTrace;
